import { CropperModalContent } from './CropperModal/CropperModalContent';
import { GetRecommendationsModal } from './GetRecommendationsModal';
import { MembershipDiscountModal } from './MembershipDiscountModal';

enum ModalName {
  Cropper = 'Cropper',
  GetRecommendations = 'GetRecommendations',
  MembershipDiscount = 'MembershipDiscount'
}

const DefaultModalClasses = 'border-2 border-neutral-200 p-5 rounded-md bg-white xs:w-full md:w-2/5 overflow-x-hidden overflow-y-auto relative top-20 mx-auto';
const FullScreenModalClasses = 'rounded-md xs:w-full md:w-2/5 md:border-neutral-200 overflow-x-hidden overflow-y-auto relative md:top-20 mx-auto';

const modalConfig = {
  [ModalName.Cropper]: {
    modal: CropperModalContent,
    classes: 'border-2 border-neutral-200 p-5 rounded-md bg-white w-full md:w-[600px] xl:w-[700px] overflow-x-hidden overflow-y-auto relative top-10 mx-auto',
  },
  [ModalName.GetRecommendations]: {
    modal: GetRecommendationsModal,
    classes: DefaultModalClasses,
  },
  [ModalName.MembershipDiscount]: {
    modal: MembershipDiscountModal,
    classes: FullScreenModalClasses,
  }
};

export { modalConfig, ModalName };
